import { render, staticRenderFns } from "./service2.vue?vue&type=template&id=712b8e1d&scoped=true&"
import script from "./service2.vue?vue&type=script&lang=js&"
export * from "./service2.vue?vue&type=script&lang=js&"
import style0 from "./service2.vue?vue&type=style&index=0&id=712b8e1d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712b8e1d",
  null
  
)

export default component.exports